export default __webpack_public_path__ + "./images/je.223b5176.png";